import { stringifyForAttribute } from '@kissui/helpers/src/utils'

export const renderEnergyLabel = props => {
    const { a11y_energy_label, energy_level } = props

    if (!energy_level) {
        return ''
    }

    const data = {
        a11y_label: a11y_energy_label,
        level: energy_level
    }

    return `<nb-energy-label data='${stringifyForAttribute(data)}'></nb-energy-label>`
}
